import {
  Component,
  EventEmitter,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/services/global-variables';
import { BrowserStorageService } from 'src/app/services/browser-storage.service';

@Component({
  selector: 'app-card-switch',
  templateUrl: './card-switch.component.html',
  styleUrls: ['./card-switch.component.scss'],
  providers: [ApiService],
})
export class CardSwitchComponent implements OnInit {
  userCards: any = [];
  selectedCardId: any;
  @ViewChild('cardSwitch') cardSwitch: TemplateRef<any> | any;
  emitCloseSwitchPanelEvent: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    public _apiService: ApiService,
    private _auth: AuthenticationService,
    private toastr: ToastrService,
    public GlobalConstants: GlobalConstants,
    private browserStore: BrowserStorageService
  ) {
    this.getCards();
  }

  ngOnInit(): void {
    if (localStorage.getItem('userCard')) {
      this.selectedCardId = JSON.parse(this.browserStore.get('userCard')).id;
    }
  }

  getCards() {
    let userCards = JSON.parse(this.browserStore.get('userCards'));
    console.log(userCards,'browserStore');
    if (userCards && userCards.length > 0) {
      this.userCards = userCards;
    } else {
      this._apiService.getCards().subscribe(
        (res) => {
          if (res && res.data) {
            this.userCards = res.data;
            this.browserStore.set('userCards', JSON.stringify(this.userCards));
          }
        },
        (err) => {
          this.toastr.error(
            'An error occured while fetching the cards! Please try again.'
          );
          setTimeout(() => {
            this.emitCloseSwitchPanelEvent.emit('error');
          }, 3000);
        }
      );
    }
  }

  setCard(each: any) {
    this._apiService.switchCard(each.attributes.id).subscribe((res) => {
      if (
        res &&
        res.data &&
        res.data.attributes.bin == each.attributes.bin &&
        res.data.attributes.status == 'bin_verified'
      ) {
        let current_user = JSON.parse(this.browserStore.get('currentUser'));
        if (current_user.skipExceptCard) {
          current_user.skipExceptCard = false;
        }
        current_user.token = res.data.attributes.session_token;
        this.browserStore.set('currentUser', JSON.stringify(current_user));
        this.browserStore.set('card_verified', 'true');
        this.browserStore.set('userCard', JSON.stringify(res.data));
        this.browserStore.set('skipReloadLogout', 'true', 'session');
        this.emitCloseSwitchPanelEvent.emit('success');
        setTimeout(() => {
          this._auth.reloadInit.emit(true);
        }, 1000);
      } else {
        this.browserStore.set('card_verified', 'false');
      }
    });
  }
  closePanel() {
    this.emitCloseSwitchPanelEvent.emit('close');
  }
}
